import { render, staticRenderFns } from "./replacePersonnelModel.vue?vue&type=template&id=0ae2ac27&scoped=true"
import script from "./replacePersonnelModel.vue?vue&type=script&lang=js"
export * from "./replacePersonnelModel.vue?vue&type=script&lang=js"
import style0 from "./replacePersonnelModel.vue?vue&type=style&index=0&id=0ae2ac27&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae2ac27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ae2ac27')) {
      api.createRecord('0ae2ac27', component.options)
    } else {
      api.reload('0ae2ac27', component.options)
    }
    module.hot.accept("./replacePersonnelModel.vue?vue&type=template&id=0ae2ac27&scoped=true", function () {
      api.rerender('0ae2ac27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/customerManage/correctionApplication/replacePersonnelModel.vue"
export default component.exports